import type { PreparedAttachment } from '../../domain/capture/model';
import { NookError } from '../../domain/shared/errors';

export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export async function prepareImage(file: File): Promise<PreparedAttachment> {
  if (!file.size || file.size > MAX_IMAGE_BYTES) throw new NookError('attachment', '当前预览支持每张不超过 10 MB 的图片。图片未保存，文字不受影响。');
  const bytes = new Uint8Array(await file.arrayBuffer());
  let mime = '';
  const ascii = (a: number, b: number) => new TextDecoder().decode(bytes.slice(a, b));
  if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) mime = 'image/jpeg';
  else if (bytes[0] === 0x89 && ascii(1, 4) === 'PNG') mime = 'image/png';
  else if (/^GIF8[79]a$/.test(ascii(0, 6))) mime = 'image/gif';
  else if (ascii(0, 4) === 'RIFF' && ascii(8, 12) === 'WEBP') mime = 'image/webp';
  else if (ascii(4, 8) === 'ftyp' && /avif|avis/.test(ascii(8, 32))) mime = 'image/avif';
  else if (ascii(4, 8) === 'ftyp' && /heic|heix|hevc|hevx|mif1/.test(ascii(8, 32))) mime = 'image/heic';
  if (!mime) throw new NookError('attachment', '这不是当前支持的图片文件。SVG 和其他可执行内容不会作为图片导入。');
  const hash = await crypto.subtle.digest('SHA-256', bytes);
  const sha256 = [...new Uint8Array(hash)].map((b) => b.toString(16).padStart(2, '0')).join('');
  const now = new Date().toISOString();
  return {
    metadata: { id: crypto.randomUUID(), name: file.name, mime, bytes: file.size, sha256, indexStatus: 'metadata_only', createdAt: now, updatedAt: now, revision: 1, source: 'user', archivedAt: null, deletedAt: null },
    data: { sha256, bytes: file.size, blob: new Blob([bytes], { type: mime }) },
  };
}
